import { AppTableProps } from 'components/organisms';
import { GetGroupsFilterKey, GetGroupsFilters, GroupDTO } from 'types';
import { groupDTOFields } from 'consts/group/groupDTOFields';
import { groupTableAdditionalColumnsKeys } from 'consts/group/groupTableAdditionalColumnsKeys';
import {
    CountDisplay,
    GroupTeacherDisplay,
    SchoolYearsDisplay,
    PersonListDisplay,
    TableTagDisplay,
} from 'components/molecules';
import { commonTexts } from 'consts/text';
import { groupStatusesLabels } from 'consts/group/groupStatusesLabels';
import { PageFilter } from 'hooks/usePageFilters/usePageFilters';

export const getColumns: (filtersValues: GetGroupsFilters) => AppTableProps<GroupDTO>['columns'] = (
    filtersValues,
) => [
    {
        title: 'Stworzone grupy',
        dataIndex: groupDTOFields.name,
        key: groupDTOFields.name,
        width: '15%',
        mobileWidth: '60%',
    },
    {
        title: 'Liczba dzieci',
        dataIndex: groupTableAdditionalColumnsKeys.childCount,
        key: groupTableAdditionalColumnsKeys.childCount,
        align: 'center',
        render: (_, group) => <CountDisplay count={group[groupDTOFields.childrenArray].length} />,
        width: '25%',
        mobileWidth: '30%',
    },
    {
        title: 'Nauczyciele',
        dataIndex: groupDTOFields.teachers,
        key: groupDTOFields.teachers,
        render: (teachers: GroupDTO['teachers']) => (
            <GroupTeacherDisplay groupTeachers={teachers} />
        ),
        isInvisibleInMobile: true,
        width: '30%',
    },
    {
        title: commonTexts.dataLabels.status,
        dataIndex: groupDTOFields.status,
        key: groupDTOFields.status,
        align: 'center',
        render: (status: GroupDTO['status']) => (
            <TableTagDisplay value={status} labelMapper={groupStatusesLabels} />
        ),
        isVisibleAsExtendableInMobile: true,
        width: '10%',
    },
    {
        title: 'Obecne dzieci',
        dataIndex: groupDTOFields.childrenArray,
        key: groupDTOFields.childrenArray,
        render: (childrenArray: GroupDTO['childrenArray']) => (
            <PersonListDisplay personsData={childrenArray} />
        ),
        isInvisibleInDesktop: true,
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: commonTexts.dataLabels.schoolYear,
        dataIndex: groupDTOFields.schoolYears,
        key: groupDTOFields.schoolYears,
        render: (schoolYears: GroupDTO['schoolYears']) => (
            <SchoolYearsDisplay
                schoolYears={schoolYears}
                fromYearFilter={filtersValues.fromYear}
                toYearFilter={filtersValues.toYear}
            />
        ),
        isVisibleAsExtendableInMobile: true,
        width: '20%',
    },
];

export const filters: PageFilter<GetGroupsFilterKey>[] = [
    { name: 'fromYear', type: 'SINGLE_VALUE' },
    { name: 'toYear', type: 'SINGLE_VALUE' },
];
